export type UserTagPayload = {
  user_type: string;
};
export type MeetingIdTagPayload = {
  bet_reunion_id: string;
};
export type RaceTagPayload = {
  bet_course_id: string;
  etat_course: string | null;
  discipline: string;
};
export type QuinteTagPayload = UserTagPayload &
  MeetingIdTagPayload &
  Omit<RaceTagPayload, 'etat_course'>;

export type GTMTag = { event: 'pmu_event'; page_name: string; id_pdv?: string } & Partial<
  UserTagPayload & MeetingIdTagPayload & RaceTagPayload
>;

type PlatformSpecificMethods = {
  pushTagGTM: (tag: GTMTag) => void;
};

const platformSpecificMethods: PlatformSpecificMethods = {
  pushTagGTM: () => {
    // nothing
  },
};

const initialize = ({ pushTagGTM }: PlatformSpecificMethods) => {
  platformSpecificMethods.pushTagGTM = pushTagGTM;
};

const queue: GTMTag[] = [];

const runtime = {
  ready: false,
  userData: {},
};

// The \s meta character in JavaScript regular expressions matches any whitespace character: spaces, tabs, newlines and Unicode spaces.
// The g flag in regex tells JavaScript to replace it multiple times.
const formatEvent = (event: string) =>
  event.toLowerCase().replaceAll('&', '_and_').replaceAll(/\s/g, '_').replaceAll('__', '_');

const sendTag = (event: string, data?: Omit<GTMTag, 'event' | 'page_name'>) => {
  const formattedEvent = formatEvent(event);

  const preparedData: GTMTag = {
    event: 'pmu_event',
    page_name: formattedEvent,
    ...data,
  };

  if (runtime.ready) {
    platformSpecificMethods.pushTagGTM({
      ...preparedData,
      ...runtime.userData,
    });
  } else {
    queue.push(preparedData);
  }
};

export { formatEvent, initialize, platformSpecificMethods, queue, runtime, sendTag };
